export interface UserFeedback {
  id: string;
  userId: string;
  userEmail: string;
  feedbackType: string;
  category: string;
  responses: Record<string, unknown>;
  additionalComments?: string;
  status: FeedbackStatus;
  submittedAt: string;
  reviewedAt?: string;
  reviewedBy?: string;
  adminNotes?: string;
  metadata: Record<string, unknown>;
  updatedAt: string;
}

export enum FeedbackStatus {
  Pending = 0,
  Reviewed = 1,
  Actioned = 2,
  Closed = 3
}

export enum FeedbackType {
  TrialExtension = 0,
  FeatureRequest = 1,
  BugReport = 2,
  GeneralFeedback = 3,
  SupportRequest = 4
}

export enum FeedbackCategory {
  Billing = 0,
  Features = 1,
  Support = 2,
  Trial = 3,
  Technical = 4,
  General = 5
}

export interface CreateFeedbackRequest {
  userId: string;
  userEmail: string;
  feedbackType: string;
  category: string;
  responses: Record<string, unknown>;
  additionalComments?: string;
  metadata: Record<string, unknown>;
}

export interface TrialExtensionFeedbackRequest {
  userId: string;
  userEmail: string;
  preventingUpgrade: string;
  desiredFeatures: string;
  budgetConcerns: string;
  timeline: string;
  additionalComments?: string;
  preventingUpgradeOther?: string;
  desiredFeaturesOther?: string;
  budgetConcernsOther?: string;
  trialDaysRemaining: number;
}

export interface UpdateFeedbackStatusRequest {
  status: FeedbackStatus;
  reviewedBy?: string;
  adminNotes?: string;
}

export interface PaginatedFeedbackResponse {
  feedback: UserFeedback[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface FeedbackAnalyticsResponse {
  totalFeedback: number;
  typeCounts: Record<string, number>;
  statusCounts: Record<string, number>;
}
